import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Form, Button, Spinner, Card, Alert, Tooltip, OverlayTrigger } from "react-bootstrap";
import DataTable from "react-data-table-component";
import SupplierService from "../../services/master/SupplierService.js";
import Select from "react-select";
import {FaTrash} from "react-icons/fa";
import Swal from "sweetalert2";

const EditSupplier = () => {
  const navigate = useNavigate();
  const [supplierData, setSupplierData] = useState(null);
  const [upiRegisters, setUpiRegisters] = useState([]);
  const [selectedReg, setSelectedReg] = useState("");
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSup, setLoadingSup] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [formSuppliers, setFormSuppliers] = useState([{}]);
  const [listUPT, setListUPT] = useState([]);

  // Ambil data dari local storage
  useEffect(() => {
  const fetchData = async () => {
    try {
      const storedData = localStorage.getItem("editSupplierData");

      if (!storedData) {
        setError("Data supplier tidak ditemukan");
        setLoading(false);
        return;
      }

      const parsedData = JSON.parse(storedData);
      //console.log("STORED DATA:", parsedData);

      //  cek detail HACCP & UPI berdasarkan ID
      const regData = await SupplierService.getUpiHaccpId(parsedData.id_haccp);

      if (regData) {
        setSupplierData({
          ...parsedData,
          ...(regData.data || regData), 
        });

      
        if (Array.isArray(regData.regs)) {
          setUpiRegisters(regData.regs);
        }
      } else {
        setSupplierData(parsedData); 
      }

      const suppRes = await SupplierService.getAllSuppliers();
      setAllSuppliers(Array.isArray(suppRes) ? suppRes : []);

        if (parsedData.id_haccp) {
        setLoadingSup(true);
        const supRes = await SupplierService.getSupplierWithRegisterById(parsedData.id_haccp);
        // console.log("DATA SUPPLIER WITH REG:", supRes);

        const supplierArray = Array.isArray(supRes) ? supRes : [supRes];
        setSuppliers(supplierArray);
        setLoadingSup(false);
      }

      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      const errorMessage = err.response?.data?.message || "Gagal memuat data supplier";
      setError(errorMessage);
      setUpiRegisters([]);
      setSuppliers([]);
      setLoading(false);
    }
  };

  fetchData();
}, []);


  useEffect(() => {
    const fetchUPT = async () => {
      try {
        const res = await SupplierService.getAllUPT();
        // console.log("DATA UPT:", res.data); 
  
        if (Array.isArray(res.data)) {
          setListUPT(res.data);
        } else if (Array.isArray(res.data.data)) {
          setListUPT(res.data.data); 
        } else {
          console.warn("Data UPT bukan array:", res.data);
          setListUPT([]);
        }
      } catch (err) {
        console.error("Gagal ambil data UPT", err);
        setListUPT([]);
      }
    };
  
    fetchUPT();
  }, [SupplierService]);

  const handleAddSupplier = async (e) => {
    e.preventDefault();
    const ID_HACCP = supplierData.id_haccp || supplierData.idHaccp;
    const UPI_ID = supplierData.UPI_ID || supplierData.upiId;
    const UPI_REG_ID = supplierData.UPI_REG_ID || selectedReg;

    const suppliersToSave = formSuppliers.filter((s) => s.id_supp);

    if (!ID_HACCP || !UPI_ID || !UPI_REG_ID || suppliersToSave.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Harap pastikan semua data tersedia.",
      });
      return;
    }

    try {
      for (let supp of suppliersToSave) {
        const payload = {
          ID_HACCP: supplierData.idHaccp || supplierData.id_haccp,
          UPI_ID,
          UPI_REG_ID,
          ID_SUPP: supp.id_supp,
        };
        await SupplierService.createUpiSupplier(payload);
      }

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Supplier berhasil ditambahkan ke register.",
      });

      setFormSuppliers([{}]); 
      setError("");
      setSuccess("Supplier berhasil ditambahkan");

      // Refresh daftar supplier
      setLoadingSup(true);
      const supData = await SupplierService.getSupplierWithRegisterById(ID_HACCP);
      setSuppliers(Array.isArray(supData) ? supData : []);
      setLoadingSup(false);

      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
        console.error(err);
        const errorMessage =
          err.response?.data?.error || "Terjadi kesalahan saat menambahkan supplier.";
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: errorMessage,
        });

        setError(errorMessage);
}
  };

  const confirmDelete = (id) => {
  Swal.fire({
    title: "Apakah Anda yakin?",
    text: "Data supplier akan dihapus permanen!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  }).then((result) => {
    if (result.isConfirmed) {
      handleDeleteSupplier(id);
    }
  });
};

const handleDeleteSupplier = async (id) => {
  try {
    await SupplierService.deleteSupplierById(id);
     const ID_HACCP = supplierData.id_haccp || supplierData.idHaccp;

    // refresh daftar supplier berdasarkan ID_HACCP
    setLoadingSup(true);
    const supData = await SupplierService.getSupplierWithRegisterById(ID_HACCP);
    setSuppliers(Array.isArray(supData) ? supData : []);
    setLoadingSup(false);

    Swal.fire({
      icon: "success",
      title: "Berhasil",
      text: "Supplier berhasil dihapus.",
    });
  } catch (err) {
    console.error(err);
    const errorMessage =
      err.response?.data?.error || "Terjadi kesalahan saat menghapus supplier.";
    Swal.fire({
      icon: "error",
      title: "Gagal",
      text: errorMessage,
    });
  }
};

  const handleBack = () => {
    localStorage.removeItem("editSupplierData");
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error && !supplierData) {
    return (
      <Alert variant="danger" className="m-3">
        {error}
        <div className="mt-2">
          <Button variant="secondary" onClick={handleBack}>
            Kembali
          </Button>
        </div>
      </Alert>
    );
  }

  return (
    <div className="container-fluid">
      <Row className="mb-3">
        <Col>
          <Button variant="outline-secondary" onClick={handleBack} className="mb-3">
            &larr; Kembali
          </Button>
          <h3>Edit Supplier HACCP</h3>
        </Col>
      </Row>

      {/* Informasi UPI */}
      {supplierData && (
        <div className="p-3 border rounded mb-3 bg-white">
          <h5 className="mb-3">Informasi UPI</h5>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Nama UPI</Form.Label>
                <Form.Control value={supplierData.nama_upi} readOnly />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Alamat UPI</Form.Label>
                <Form.Control value={supplierData.UPI_ALAMAT} readOnly />
              </Form.Group>
            </Col>
          </Row>
        </div>
      )}

      {/* Informasi HACCP */}
      {supplierData && (
        <div className="p-3 border rounded mb-3 bg-light">
          <h5 className="mb-3">Informasi HACCP</h5>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>No HACCP</Form.Label>
                <Form.Control value={supplierData.no_haccp} readOnly />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Tgl Berlaku</Form.Label>
                <Form.Control
                  value={new Date(supplierData.tgl_berlaku).toLocaleDateString()}
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Komoditas</Form.Label>
                <Form.Control value={supplierData.komoditas} readOnly />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-2">
                <Form.Label>Grade</Form.Label>
                <Form.Control value={supplierData.grade} readOnly />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-2">
                <Form.Label>Status</Form.Label>
                <Form.Control value={supplierData.status_sert} readOnly />
              </Form.Group>
            </Col>
          </Row>
        </div>
      )}

      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}

      {/* Tambah Supplier */}
      <Card className="mb-4">
        <Card.Header>
          <h5>Tambah Supplier ke Register</h5>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleAddSupplier}>
            {formSuppliers.map((_, index) => (
              <Row key={index} className="align-items-end mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Pilih Supplier</Form.Label>
                    <Select
                      options={allSuppliers.map((s) => ({
                        value: s.id_supp,
                        label: `${s.no_supp} - ${s.nama_supp} - ${s.jenis_produk}`,
                        detail: s,
                      }))}
                      onChange={(selectedOption) => {
                        const newFormSuppliers = [...formSuppliers];
                        newFormSuppliers[index] = selectedOption?.detail || {};
                        setFormSuppliers(newFormSuppliers);
                      }}
                      placeholder="Ketik untuk mencari supplier..."
                      isClearable
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  {formSuppliers[index]?.id_supp && (
                    <div className="p-2 border rounded bg-light">
                      <p className="mb-1">
                        <b>No Supplier:</b> {formSuppliers[index].no_supp}
                      </p>
                      <p className="mb-1">
                        <b>Nama:</b> {formSuppliers[index].nama_supp}
                      </p>
                      <p className="mb-1">
                        <b>Komoditas:</b> {formSuppliers[index].jenis_produk}
                      </p>
                    </div>
                  )}
                </Col>

                <Col md={2}>
                  {index > 0 && (
                    <Button
                      variant="danger"
                      onClick={() =>
                        setFormSuppliers(formSuppliers.filter((_, i) => i !== index))
                      }
                    >
                      Hapus
                    </Button>
                  )}
                </Col>
              </Row>
            ))}

            <Button
              type="button"
              variant="secondary"
              onClick={() => setFormSuppliers([...formSuppliers, {}])}
            >
              + Tambah Supplier
            </Button>

            <Button type="submit" variant="primary" className="ms-2">
              Simpan
            </Button>
          </Form>
        </Card.Body>
      </Card>

      {/* Daftar Supplier */}
      <Card>
        <Card.Header>
          <h5>Daftar Supplier Terdaftar</h5>
        </Card.Header>
        <Card.Body>
          <DataTable
            columns={[
              { name: "No. Supplier", selector: (row) => row.no_supp || "-", wrap: true },
              { name: "Nama Supplier", selector: (row) => row.nama_supp || "-", wrap: true },
              { name: "Jenis Produk", selector: (row) => row.jenis_produk || "-", wrap: true },
              // { name: "Asal UPT", 
              //   selector: (row) => {
              //     const upt = listUPT.find((u) => u.kode_upt === row.kode_upt);
              //     return upt ? upt.nm_pendek : row.kode_upt || "-";
              //   }, 
              //   wrap: true 
              // },
              { name: "Status", selector: (row) => row.sts_aktif ?? "-", wrap: true },
              {
                    name: "Action",
                    width: "100px",
                    cell: (row) => (
                      <OverlayTrigger placement="bottom" overlay={<Tooltip>Hapus Data Supplier</Tooltip>}>
                        <Button
                          size="sm"
                          variant="danger"
                          onClick={(e) => {
                           confirmDelete(row.ID_SUPP_UPI);
                          }}
                        >
                          <FaTrash />
                        </Button>
                      </OverlayTrigger>
                    ),
                  },,
            ]}
            data={Array.isArray(suppliers) ? suppliers : []}
            dense
            progressPending={loadingSup}
            progressComponent={<Spinner animation="border" size="sm" />}
            noDataComponent="Tidak ada data supplier"
            customStyles={{
              headCells: {
                style: {
                  backgroundColor: "#fc8c4bff",
                  color: "#000",
                  fontWeight: "600",
                  paddingLeft: "20px",
                },
              },
              cells: {
                style: {
                  paddingLeft: "20px",
                  whiteSpace: "normal",
                },
              },
            }}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default EditSupplier;
